import { __awaiter, __generator } from "tslib";
import { bootstrapFeature, initialize, preloadFeature, } from '@ms/centro-hvc-loader';
import { FEEDBACK_DIV_ID, OCV_IN_APP_FEEDBACK_FEATURE } from './constants';
/**
 * These following functions are owned by the VNext Feedback SDK RDX Team
 *
 * It is important for us to ensure that these functions are not edited without the permission of the RDX team
 * in order to avoid any discrepencies.
 *
 * Feedback Engineer Contact: Akhil Ravindran (akravindran@microsoft.com)
 * Feedback PM Contact: Clodagh Lancaster (clodagh.lancaster@microsoft.com)
 *
 * Last Updated: 9/7/2023
 * Eng: Yamini Talasila (ytalasila@microsoft.com)
 */
/**
 * This function will be set by the HVC bootstrapper
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
var unmountFunction = function () { };
/**
 * Immediately invoke to 'capture' feedbackData and listeners
 */
var inAppFeedbackInitOptionsListener = (function () {
    var feedbackData = {};
    var listeners = [];
    return {
        register: function (listener) {
            if (listener) {
                listeners.push(listener);
            }
            return feedbackData;
        },
        unregister: function (listener) {
            var index = listeners.indexOf(listener);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        },
        updateFeedbackObject: function (updatedInAppFeedbackInitOptions) {
            Object.assign(feedbackData, updatedInAppFeedbackInitOptions);
            listeners.forEach(function (listener) {
                return listener(feedbackData);
            });
        },
    };
})();
var getDivToMountHvc = function (inAppFeedbackRef) {
    var hvcDiv;
    if (inAppFeedbackRef) {
        hvcDiv = document.getElementById(inAppFeedbackRef);
    }
    if (!hvcDiv) {
        hvcDiv = document.getElementById(FEEDBACK_DIV_ID);
    }
    if (!hvcDiv) {
        hvcDiv = document.createElement('div');
        hvcDiv.id = FEEDBACK_DIV_ID;
        document.body.appendChild(hvcDiv);
    }
    return hvcDiv;
};
export var initializeInAppFeedback = function (initializationInfo) {
    (function () { return __awaiter(void 0, void 0, void 0, function () {
        var fluentModalDiv, hostName, language, inAppFeedbackRef, bootstrapper;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    unmountFunction();
                    fluentModalDiv = document.getElementById('fluent-default-layer-host');
                    if (fluentModalDiv) {
                        (_a = fluentModalDiv.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(fluentModalDiv);
                    }
                    hostName = initializationInfo.hostName, language = initializationInfo.language, inAppFeedbackRef = initializationInfo.inAppFeedbackRef;
                    return [4 /*yield*/, initialize({
                            // Please use Centro Prod Url even for development to get the latest released of the HVC
                            // Centro CI Url can also be used for unreleased features
                            centroEnvironmentBaseUrl: 'https://admin.microsoft.com',
                            preConfig: {
                                hostName: hostName,
                                locale: language,
                                // All perf log will be prefixed with this string.
                                // So that when Centro team analyzes perf logs, they know that those logs are coming from HVC running in our environment.
                                perfPrefix: "OcvFeedback".concat(hostName),
                            },
                            centroHvcData: '',
                            forHostVersion: 'v2',
                            hvcVersion: '', // to retrieve specific version of HVC
                            // Note: do not specify both forHostVersion and hvcVersion
                        }).catch(function (e) {
                            // $TODO: Log
                            console.info('Failed to initialize centro', e);
                        })];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, preloadFeature({
                            featureName: OCV_IN_APP_FEEDBACK_FEATURE,
                            adapters: {
                                dataSources: function (setDataSource) {
                                    setDataSource('centro.hvc.feedback.initOptions', inAppFeedbackInitOptionsListener);
                                },
                            },
                        }).catch(function (e) {
                            // $TODO: Log
                            console.info('Failed to preload centro feature', e);
                        })];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, bootstrapFeature({
                            featureName: OCV_IN_APP_FEEDBACK_FEATURE,
                        })];
                case 3:
                    bootstrapper = _b.sent();
                    return [4 /*yield*/, bootstrapper.main(getDivToMountHvc(inAppFeedbackRef))];
                case 4:
                    // Mounting the HVC on the provided HTML element
                    unmountFunction = _b.sent();
                    return [2 /*return*/];
            }
        });
    }); })();
};
export var updateFeedbackOptions = inAppFeedbackInitOptionsListener.updateFeedbackObject;
//# sourceMappingURL=CentroFeedbackFunctions.js.map